import React from "react";
import { Tooltip } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import TranslationForm from "./TranslationForm";
import withIntl from "../../utils/withIntl";
import { useDialog } from "../Dialogs/DialogProvider";
import Flag from "react-flags";
import getFlagName from "../../helper/GetFlagName";
import cloudStore from "../../store/CloudStore";

function TranslationFormButton(props) {
  const [openDialog] = useDialog();

  if (!cloudStore.merchant.languages) {
    return <></>;
  }
  return (
    <Tooltip title={props.intl.formatMessage({ id: "translate" })}>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          openDialog({
            children: (
              <TranslationForm
                translationField={props.translationField}
                updateTranslations={props.updateTranslations}
                translationsObject={props.translationsObject}
                translationFields={props.translationFields}
              />
            ),
            fullWidth: true,
            maxWidth: "xs",
          });
        }}
      >
        <Flag
          name={getFlagName(cloudStore.merchant.default_language)}
          format="png"
          pngSize={16}
          shiny={true}
          basePath={"/flags"}
        />
      </IconButton>
    </Tooltip>
  );
}

export default withIntl(TranslationFormButton);
